/* estados de la aplicacion author */
const state = {
  // para cargar home
  loadHome: false,
  dataHome: null
}

export default state
